import useSWR from 'swr';

import useGlobalState from '~utils/hooks/useGlobalState';

import { Membership, User } from '~types';

type Status = 'loading' | 'success' | 'error';

const useMembership = (): { data: Membership | undefined; status: Status } => {
  const [user] = useGlobalState<User>('user');
  const [sessionResumed] = useGlobalState('sessionResumed');
  const { data, error, isLoading, mutate } = useSWR<Membership>(
    sessionResumed && user?.Profile?.loyaltyActivated ? '/profile/membership' : null,
  );
  if (error?.message === 'Could not find any members.') {
    mutate(data, true);
  }
  let status: Status = 'success';
  if (error) status = 'error';
  if (isLoading) status = 'loading';
  return { data, status };
};

export default useMembership;
